export const GENERIC_HEADERS = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
};
export function buildQueryParams(customerId, hash, associateId) {
    return `?customer=${customerId}&hash=${hash}${associateId ? '&associate=' + associateId : ''}`;
}
